import NewspaperEditors from './NewspaperEditors'

export default NewspaperEditors
